import { Box, Typography } from "@mui/material";
import FormActionButton from "../../buttons/formActionButton.component";
import { Add } from "@mui/icons-material";
import { useCallback } from "react";
import CropHistoryRow from "./cropHistoryRow.component";
import { getRangesForRow } from "./utils";
import { useSelector } from "react-redux";
import { CROP_HISTORY_CONFIG } from "./constants";
import { useCropHistoryData } from "./hooks/useCropHistoryData";

const CropHistoryForm = ({
  theme,
  crops,
  onSubmit,
  formData,
  fieldToUpdate,
  fieldForm,
}) => {
  const { rows, allRowsData, addRow, deleteRow, updateRowData } =
    useCropHistoryData(formData, fieldForm);

  const genericInfoData = useSelector(
    (state) => state.fieldForm?.formData?.genericInfo
  );

  const genericInfo = fieldToUpdate || genericInfoData;

  const handleFormSubmit = useCallback(
    (e) => {
      e.preventDefault();
      const dataArray = Object.values(allRowsData);
      onSubmit(dataArray);
    },
    [allRowsData, onSubmit]
  );

  const handleDeleteRow = useCallback(
    (id) => {
      deleteRow(id);
    },
    [deleteRow]
  );

  const handleRowDataUpdate = useCallback(
    (rowId, data) => {
      updateRowData(rowId, data);
    },
    [updateRowData]
  );

  return (
    <Box
      component="form"
      id={CROP_HISTORY_CONFIG.FORM_ID}
      onSubmit={handleFormSubmit}
      display="flex"
      flexDirection="column"
      gap={2}
      mb={2}
      height="100%"
      overflow="auto"
    >
      <Typography fontWeight="bold" fontSize="16px">
        {CROP_HISTORY_CONFIG.TITLE}
      </Typography>
      <Typography fontSize="12px" color={theme.palette.custom.infoTextColor}>
        {CROP_HISTORY_CONFIG.DESCRIPTION}
      </Typography>
      {rows.map((row, index) => (
        <CropHistoryRow
          key={`${row.id}-${index}`}
          crops={crops}
          onDelete={() => handleDeleteRow(row.id)}
          theme={theme}
          onSubmit={(data) => handleRowDataUpdate(row.id, data)}
          allRowsData={allRowsData}
          rowId={row.id}
          initialData={allRowsData[row.id]}
          fieldToUpdate={fieldToUpdate}
          formData={formData["Storico colture"]}
          ranges={getRangesForRow(row.id, genericInfo, allRowsData)}
        />
      ))}
      <FormActionButton
        startIcon={<Add />}
        label={CROP_HISTORY_CONFIG.ADD_BUTTON_LABEL}
        onClick={addRow}
      />
    </Box>
  );
};

export default CropHistoryForm;
